import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { Tooltip } from './ui';

/**
 * ThemeToggle — pill switch con sol y luna.
 * Tamaño coherente con el resto del Topbar (h-10 = 40px).
 */
const ThemeToggle = () => {
    const { theme, toggle } = useTheme();
    const isDark = theme === 'dark';
    const label = isDark ? 'Cambiar a claro' : 'Cambiar a oscuro';

    return (
        <Tooltip content={label}>
        <button
            type="button"
            onClick={toggle}
            role="switch"
            aria-checked={isDark}
            aria-label={label}
            className="
                relative inline-flex items-center
                w-[72px] h-10 rounded-full
                bg-surface-2 border border-line
                hover:border-primary/40
                transition
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40
            "
        >
            {/* Indicador (circulo blanco que se desliza) */}
            <span
                aria-hidden="true"
                className="
                    absolute top-1 left-1
                    w-8 h-8 rounded-full
                    bg-white shadow-soft
                    transition-transform duration-200 ease-out
                "
                style={{ transform: isDark ? 'translateX(32px)' : 'translateX(0)' }}
            />

            {/* Iconos (ambos siempre visibles) */}
            <span className="relative z-10 flex-1 flex items-center justify-center">
                <Sun size={16} className={isDark ? 'text-muted' : 'text-amber-500'} />
            </span>
            <span className="relative z-10 flex-1 flex items-center justify-center">
                <Moon size={16} className={isDark ? 'text-slate-700' : 'text-muted'} />
            </span>
        </button>
        </Tooltip>
    );
};

export default ThemeToggle;
